/**
 * 監査ログ。誰がいつ何を承認・確定・変更したかを追記のみで残す。
 * セキュリティルール上、audit_logs は作成のみ許可(更新・削除は誰にもできない)。
 *
 * 記録に失敗しても業務処理は止めない(ログのために承認が失敗する方が損失が大きい)。
 * 失敗はコンソールに出す。
 */
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { getDb } from './firebase';

export type AuditTargetType = 'transaction' | 'user' | 'master';

export async function writeAuditLog(params: {
  targetType: AuditTargetType;
  targetId: string;
  action: string;
  by: string;
  before?: Record<string, unknown> | null;
  after?: Record<string, unknown> | null;
}): Promise<void> {
  try {
    await addDoc(collection(getDb(), 'audit_logs'), {
      target_type: params.targetType,
      target_id: params.targetId,
      action: params.action,
      by: params.by,
      at: serverTimestamp(),
      before: params.before ?? null,
      after: params.after ?? null,
    });
  } catch (e) {
    console.error('監査ログの記録に失敗しました', e);
  }
}
